// components/Admin/AreaSplitChart.js
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { Box, Typography } from "@mui/material";
import instance from "../../globals/axios";
import { useAlert } from "../Alert";
import { useTranslation } from "react-i18next";
import { isNotNullOrEmptyArray } from "../../globals/utils";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SERVER_BASE_ADDRESS } from "../../globals/const";

const AreaSplitChart = () => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const { access_key } = useParams();
  const isReport = !!access_key;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response;

        if (isReport) {
          const url = `${SERVER_BASE_ADDRESS}/app-admin/get-farm-area-split-metrics/`;
          response = await axios.get(url, {
            headers: {
              Authorization: `Token ${access_key}`,
            },
          });
        } else {
          response = await instance.get(
            "/app-admin/get-farm-area-split-metrics/"
          );
        }

        if (response?.data?.data) {
          setData(response.data.data);
        } else {
          showAlert("error", "Failed to fetch data");
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
        showAlert("error", "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];

  return (
    <Box sx={{ padding: "16px", height: "300px" }}>
      {!isReport && loading ? (
        <Typography variant="h6">{`${t("Loading")}...`}</Typography>
      ) : isNotNullOrEmptyArray(data) ? (
        <>
          <PieChart width={400} height={300}>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
              isAnimationActive={!isReport}
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography variant="h6">{t("No data available")}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default AreaSplitChart;
